import type { Verdict } from '../types.ts';

const LABEL: Record<Verdict, string> = {
  present: 'present',
  present_as_subfeature: 'sub-feature',
  partial: 'partial',
  absent: 'absent',
  unknown: 'unknown',
};

/**
 * Verdict as a legend key (the `.key` primitive, styles.css): tinted fill, dark fg, and a 3px
 * full-strength left rule in the verdict colour — the state survives grayscale (design-system.md,
 * "Legend keys"). Class names match Verdict values, so `k-${verdict}` resolves directly.
 */
export function VerdictBadge({ verdict }: { verdict: Verdict }): JSX.Element {
  return <span className={`key k-${verdict}`}>{LABEL[verdict]}</span>;
}
